export default __webpack_public_path__ + "static/media/about.ca19c5ec.md";